import { Box } from "@chakra-ui/react";

export const HomePage = () => {
  return <Box data-testid="home-page"></Box>;
};
